import { type FC, type PropsWithChildren } from 'react'
import { Box, type BoxProps } from '@dhl-ui/components'

type Props = Pick<BoxProps, 'sx'>

export const StickySearchBoxContainer: FC<PropsWithChildren<Props>> = ({ children, sx }) => (
  <Box
    sx={{
      position: 'sticky',
      top: 0,
      px: 2,
      zIndex: (theme) => theme.zIndex.modal,
      ...sx,
    }}
  >
    {children}
  </Box>
)
